import { ofType } from 'redux-observable'
import { ignoreElements, tap } from 'rxjs/operators'
import { track } from 'tracking/mixPanel'
import * as Actions from 'store/actions/index.ts'
import { disableMixPanelTracking } from '../disable'

const mapStateToEvent = () => {
  return {
    'Click Name': 'TSF access search'
  }
}

const clickSearchButtonEpic = actions$ =>
  actions$.pipe(
    disableMixPanelTracking(actions$),
    ofType(Actions.navigation.SEARCH_BUTTON_CLICK),
    tap(() => {
      const eventName = 'Click'

      track(eventName, mapStateToEvent(), { debug: !__PRODUCTION__ })
    }),
    ignoreElements()
  )

export default clickSearchButtonEpic
